import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f8fb8de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "route-plan" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Koosta teekond", -1))
const _hoisted_3 = { class: "route-panel__section" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "route-plan__segment"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "route-plan__segment"
}
const _hoisted_8 = {
  key: 1,
  class: "route-plan__segment"
}

import { computed, PropType, ref, watch } from 'vue'
import { PublicService } from '@/models/public/bookingWidget.model'
import DatePicker from '@/components/DatePicker.vue'
import BaseAddressSearch from '@/components/BaseAddressSearch.vue'
import BaseIcon from '@/components/BaseIcon.vue'
import BaseSelect from '@/components/BaseSelect.vue'
import { Route } from '@/models/public/routePlanner.model'
import { AddressDetailsPayload } from '@/models/location.model'
import {
  formatIntlDateAndTime,
  formatMinutesToDuration,
} from '@/utils/formatters'
import RoutePlanStop from '@/components/public/route-planner/RoutePlanStop.vue'
import { calculateFinalDestinationETA } from '@/utils/route-planner'
import { Option } from '@/models/shared.model'
import { JourneyDuration } from '@/models/public/routePlanner.model'


export default /*#__PURE__*/_defineComponent({
  __name: 'RoutePlan',
  props: {
  route: {
    type: Object as PropType<Route | null>,
    default: null,
  },
  startTime: {
    type: [Date, null] as PropType<Date | null>,
    default: null,
  },
  startPoint: {
    type: Object as PropType<AddressDetailsPayload>,
    required: true,
  },
  endPoint: {
    type: Object as PropType<AddressDetailsPayload>,
    required: true,
  },
},
  emits: [
  'onSelect',
  'onRefresh',
  'onDelete',
  'onStartTimeChange',
  'onStartPointChange',
  'onStartPointUpdate',
  'onEndPointChange',
  'onEndPointUpdate',
  'onMoveStopUp',
  'onMoveStopDown',
  'onJourneyDurationChange',
],
  setup(__props, { emit: emits }) {

const props = __props



const journeyDurationOptions: Option[] = [
  { key: JourneyDuration.DAY, label: 'Päev' },
  { key: JourneyDuration.WEEK, label: 'Nädal' },
  { key: JourneyDuration.MONTH, label: 'Kuu' },
]
const selectedStopId = ref<string | null>(null)
const selectedJourneyDuration = ref<Option>()



const finalDestinationEta = computed(() =>
  calculateFinalDestinationETA(props.route),
)

const handleStopSelect = (service: PublicService) => {
  selectedStopId.value = service.id
  emits('onSelect', service)
}

const getStopLetter = (index: number) => {
  const hasStartPoint = props.startPoint.google_address.trim() !== ''
  const startIndex = hasStartPoint ? 1 : 0
  return String.fromCharCode(65 + startIndex + index)
}

const handleJourneyDurationChange = (value: JourneyDuration) => {
  selectedJourneyDuration.value = value
  emits('onJourneyDurationChange', value)
}

const clearJourneyDuration = () => {
  selectedJourneyDuration.value = null
  emits('onJourneyDurationChange', '')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(BaseSelect, {
        modelValue: selectedJourneyDuration.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((selectedJourneyDuration).value = $event)),
          handleJourneyDurationChange
        ],
        options: journeyDurationOptions,
        label: 'Teekonna kestus',
        "close-on-select": true,
        "allow-empty": true,
        "return-object": "",
        onRemove: clearJourneyDuration
      }, null, 8, ["modelValue"])
    ]),
    _createVNode(DatePicker, {
      "model-value": __props.startTime,
      name: "start",
      label: _ctx.$t('start'),
      "enable-time-picker": "",
      "min-date": new Date(),
      "month-change-on-scroll": false,
      "month-change-on-arrows": false,
      "keep-action-row": "",
      flow: ['calendar', 'time'],
      "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => emits('onStartTimeChange', value))
    }, null, 8, ["model-value", "label", "min-date"]),
    _createVNode(BaseAddressSearch, {
      result: __props.startPoint.google_address,
      placeholder: 'Alguspunkt',
      required: true,
      onOptionClick: _cache[2] || (_cache[2] = (value) => emits('onStartPointChange', value)),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = (value) => emits('onStartPointUpdate', value))
    }, null, 8, ["result"]),
    (__props.route?.stops?.length || __props.route?.segments?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (__props.route?.segments?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(BaseIcon, {
                  icon: 'car',
                  size: 16
                }),
                _createTextVNode(" " + _toDisplayString(_unref(formatMinutesToDuration)(__props.route?.segments[0]?.duration_minutes)), 1)
              ]))
            : _createCommentVNode("", true),
          (__props.route?.stops?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.route.stops, (stop, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: stop.id
                  }, [
                    _createVNode(RoutePlanStop, {
                      stop: stop,
                      route: __props.route,
                      letter: getStopLetter(index),
                      "is-selected": selectedStopId.value === stop.service.id,
                      "is-first": index === 0,
                      "is-last": index === __props.route.stops.length - 1,
                      onOnRefresh: () => emits('onRefresh', stop.service),
                      onOnDelete: () => emits('onDelete', stop),
                      onOnMoveUp: () => emits('onMoveStopUp', { stop, index }),
                      onOnMoveDown: () => emits('onMoveStopDown', { stop, index }),
                      onClick: () => handleStopSelect(stop.service)
                    }, null, 8, ["stop", "route", "letter", "is-selected", "is-first", "is-last", "onOnRefresh", "onOnDelete", "onOnMoveUp", "onOnMoveDown", "onClick"]),
                    (__props.route?.segments[index + 1])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(BaseIcon, {
                            icon: 'car',
                            size: 16
                          }),
                          _createTextVNode(" " + _toDisplayString(_unref(formatMinutesToDuration)(
                __props.route?.segments[index + 1]?.duration_minutes,
              )), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(BaseAddressSearch, {
      result: __props.endPoint.google_address,
      placeholder: 'Lõpp-punkt',
      required: true,
      onOptionClick: _cache[4] || (_cache[4] = (value) => emits('onEndPointChange', value)),
      "onUpdate:modelValue": _cache[5] || (_cache[5] = (value) => emits('onEndPointUpdate', value))
    }, null, 8, ["result"]),
    (_unref(finalDestinationEta))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Eeldatav kohalejõudmine: " + _toDisplayString(_unref(formatIntlDateAndTime)(_unref(finalDestinationEta))), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})